.formItem {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  & div div,
  & div input {
    height: 60px;
    border-radius: 40px;
    width: 100%;
    display: block;
    padding: 20px 12px 12px 24px;
    font-size: 16px;
    background: #e5ded1;
    box-sizing: border-box;
  }
}

// Dark mode
:global body.dark {
  :local {
    .formItem {
      & div div,
      & div input {
        background: #444342;
      }
    }
  }
}
